import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import Config from '@/config/config.ts';

export type EnvironmentName = 'dev' | 'preview' | 'prod';

type EnvConfig = {
  env: EnvironmentName;
  maintenanceMode: boolean;
};

type EnvFeaturesResponse = {
  env: string | undefined;
  maintenanceMode?: boolean;
};

type Return = {
  env: EnvConfig | undefined;
  isError: boolean;
  isLoading: boolean;
};

const normalizeEnvironmentName = (env: string | undefined): EnvironmentName => {
  if (env === 'prod' || env === 'preview' || env === 'dev') {
    return env;
  }

  return 'dev';
};

export const useGetEnv = (): Return => {
  const { data, isError, isFetching, isPending } = useQuery<EnvConfig>({
    queryFn: async () => {
      const { data } = await axios.get<EnvFeaturesResponse>('/env.json');
      const env = normalizeEnvironmentName(data.env);
      Config.ENVIRONMENT = env;
      return {
        env,
        maintenanceMode: data.maintenanceMode ?? false,
      };
    },
    queryKey: [QueryKeyEnum.ENV],
    staleTime: Number.POSITIVE_INFINITY,
  });

  return {
    env: data,
    isError,
    isLoading: isPending ?? isFetching,
  };
};
